import React from "react";
import Chip from "@mui/material/Chip";
import PropTypes from "prop-types";

export default function MaxChips({ maxChips, children }) {
  if (children.length > maxChips) {
    let slice = children.slice(0, maxChips);
    let rest = children.length - maxChips;

    return (
      <>
        {slice}
        <Chip label={`+${rest}`} size="small" variant="outlined" />
      </>
    );
  } else {
    return children;
  }
}

MaxChips.propTypes = {
  maxChips: PropTypes.number.isRequired,
  children: PropTypes.arrayOf(PropTypes.element),
};
